import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { ProfileSidePanelConfig } from '@se-po/shared-feature-profile-side-panel'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { Subscription } from 'rxjs'

const exampleHtml = `
  <form [formGroup]="form" class="profile-side-panel-example__fields">
    <se-fe-form-field [seFeDataConfig]="{ label: 'Org ID' }">
      <se-fe-form-field-text
        formControlName="orgId"
        seFeDataPlaceholder="Org ID">
      </se-fe-form-field-text>
    </se-fe-form-field>

    <se-fe-form-field [seFeDataConfig]="{ label: 'Persona ID' }">
      <se-fe-form-field-text
        formControlName="personaId"
        seFeDataPlaceholder="Persona ID">
      </se-fe-form-field-text>
    </se-fe-form-field>
  </form>

  <se-fe-button seFeDataType="button" (click)="showPanel = true">
    Open profile side panel
  </se-fe-button>

  <se-po-feature-profile-side-panel
    [showPanel]="showPanel"
    [config]="config"
    (closePanel)="showPanel = false">
  </se-po-feature-profile-side-panel>
`

const exampleTypescript = `
import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { ProfileSidePanelConfig } from '@se-po/shared-feature-profile-side-panel'
import { Subscription } from 'rxjs'

export class ProfileSidePanelExampleComponent implements OnDestroy, OnInit {
  public showPanel = false
  public form = new FormGroup({
    orgId: new FormControl('41400', { nonNullable: true }),
    personaId: new FormControl('75486319', { nonNullable: true }),
  })

  public config: ProfileSidePanelConfig = this.createConfig()
  private formSubscription?: Subscription

  public ngOnInit(): void {
    this.formSubscription = this.form.valueChanges.subscribe(() => {
      this.config = this.createConfig()
    })
  }

  public ngOnDestroy(): void {
    this.formSubscription?.unsubscribe()
  }

  private createConfig(): ProfileSidePanelConfig {
    return {
      orgId: this.form.controls.orgId.value,
      persona: {
        id: this.form.controls.personaId.value,
      }
    }
  }
}
`

const template = `<se-fe-docs-example [example]="this">${exampleHtml}</se-fe-docs-example>`

@Component({
  selector: 'se-po-feature-profile-side-panel-example',
  template,
  styleUrls: ['./feature-profile-side-panel-docs.component.scss'],
  standalone: false,
})
export class ProfileSidePanelExampleComponent extends SeFeDocsExampleComponent implements OnDestroy, OnInit {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  public showPanel = false
  public form = new FormGroup({
    orgId: new FormControl('41400', { nonNullable: true }),
    personaId: new FormControl(75486319, { nonNullable: true }),
  })

  public config: ProfileSidePanelConfig = this.createConfig()
  private formSubscription?: Subscription

  constructor() {
    super()
  }

  public ngOnInit(): void {
    this.formSubscription = this.form.valueChanges.subscribe(() => {
      this.config = this.createConfig()
    })
  }

  public ngOnDestroy(): void {
    this.formSubscription?.unsubscribe()
  }

  private createConfig(): ProfileSidePanelConfig {
    return {
      orgId: this.form.controls.orgId.value,
      persona: {
        id: +this.form.controls.personaId.value,
      }
    }
  }
}
